import { Typography, useTheme } from '@mui/material';
import { getLookupLabel } from '../utils';

function getLookupTextColor(theme, paletteKey) {
  if (!paletteKey || paletteKey === 'default') {
    return theme.palette.text.primary;
  }

  if (paletteKey === 'secondary') {
    return theme.palette.mutedText;
  }

  return theme.palette[paletteKey]?.main || theme.palette.text.primary;
}

function LookupChip({ lookup, colorMap }) {
  const theme = useTheme();
  const code = lookup?.code;
  const label = getLookupLabel(lookup);
  const paletteKey = colorMap?.[code];

  return (
    <Typography
      component="span"
      variant="body2"
      title={label}
      sx={{
        color: getLookupTextColor(theme, paletteKey),
      }}>
      {label}
    </Typography>
  );
}

export default LookupChip;
